import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const getLeadByUuid = async (leadUuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/lead-segurify/uuid/" + leadUuid,
    config,
  );
  return serverResponse.data;
};

export const getCampaigsByLeadUuid = async (leadUuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/origen/list/lead-segurify/" + leadUuid,
    config,
  );
  return serverResponse.data;
};

export const getCallsForLead = async (leadUuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/accion/lead-segurify/list/" + leadUuid,
    config,
  );
  return serverResponse.data;
};

export const getOrigenLeadByUUID = async (origenUuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/origen/uuid/${origenUuid}`,
    config,
  );
  return serverResponse.data;
};

export const createLeadPefai = async (id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/create/lead/pefai/${id}`,
    {},
    config,
  );
  return serverResponse.data;
};

export const getLeadEmisionesById = async (id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/emision/list/lead-segurify/${id}`,
    config,
  );
  return serverResponse.data;
};

export const updatePrimerLlamada = async (origenLeadUuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const body = {
    fechaPrimerLlamada: true,
  };

  const serverResponse = await mainAxios.post(
    `/v1/origen/actualizar/${origenLeadUuid}`,
    body,
    config,
  );
  return serverResponse.data;
};

export const updateLeadToBlackList = async (phone) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };
  const body = {
    telefono: phone,
  };

  const serverResponse = await mainAxios.post(
    `/v1/listaNegra/agregar`,
    body,
    config,
  );
  return serverResponse.data;
};

export const updateLead = async (uuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/origenlead/finalizarLlamada/` + uuid,
    {},
    config,
  );
  return serverResponse.data;
};

export const updateValidadorEstatus = async (uuid, validadorId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/origenlead/validador/update/${uuid}/${validadorId}`,
    {},
    config,
  );
  return serverResponse.data;
};

export const findLeadValidador = async (telefono) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/origenlead/find/validador/${telefono}`,
    config,
  );
  return serverResponse.data;
};

export const cleanValidadorId = async (uuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/origenlead/finalizarLlamada/validador/${uuid}`,
    config,
  );
  return serverResponse.data;
};

//Endpoint para traer lista de marcacion para validadores
export const getValidadoresLista = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/origenLead/marcacion/validacionPago`,
    config,
  );
  return serverResponse.data;
};

//Endpoint para traer lista de marcacion para agentes
export const getLlamadaMasivaOld = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    `/v1/origenLead/llamadaMasiva`,
    config,
  );
  return serverResponse.data;
};

export const getLlamadaMasiva = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/origenLead/llamadaMasiva/marcacion`,
    body,
    config,
  );
  return serverResponse.data;
};

//Detalles de un origen lead
export const getDetallesOrigenLead = async (uuid) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(`/v1/origen/uuid/${uuid}`, config);
  return serverResponse.data;
};

//Actualizar origen lead
export const updateOrigenLead = async (uuid, body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/origen/actualizar/${uuid}`,
    body,
    config,
  );
  return serverResponse.data;
};

export const createVentaPefai = async (id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    `/v1/create/venta/pefai/${id}`,
    {},
    config,
  );
  return serverResponse.data;
};

export const getAccionesLeadBotByOrigenUuid = async (body) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    "/v1/acciones/accionLead/bot/historico", 
    body,
    config
  );
  return serverResponse.data;
};